import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    GetTopicQuestionsQuery,
    GetTopicQuestionsQueryVariables,
} from "./__graphql-types__/GetTopicQuestionsQuery.ts";

// NOTE: if changing the fields fetched on feedback author you should update
// the AuthorIsVisibleToUser cross service function in
// services/discussions/cross_service/user.go
// NOTE: hardcoded `answersLimit` in query. We are now returning 1 answer per
// question for initial discussion load, and the rest with a separate query.
// TODO(ned): remove `topicSlug` once that is no longer a required field
export const GET_TOPIC_QUESTIONS_QUERY: GqlOperation<
    GetTopicQuestionsQuery,
    GetTopicQuestionsQueryVariables
> = gqlOp(gql`
    query GetTopicQuestionsQuery(
        $topicId: String!
        $cursor: String
        $limit: Int
        $feedbackType: FeedbackType
        $forceInTutorial: Boolean
        $minAnswers: Int
        $maxAnswers: Int
    ) {
        topicQuestions(
            topicID: $topicId
            topicSlug: ""
            cursor: $cursor
            limit: $limit
            feedbackType: $feedbackType
            forceInTutorial: $forceInTutorial
            minAnswers: $minAnswers
            maxAnswers: $maxAnswers
            answersLimit: 1
        ) {
            feedback {
                isLocked
                isPinned
                replyCount
                appearsAsDeleted
                author {
                    id
                    kaid
                    nickname
                    avatar {
                        name
                        imageSrc
                    }
                }
                content
                date
                definitelyNotSpam
                deleted
                downVoted
                expandKey
                feedbackType
                flaggedBy
                flaggedByUser
                flags
                focusUrl
                focus {
                    kind
                    id
                    translatedTitle
                    relativeUrl
                }
                fromVideoAuthor
                key
                lowQualityScore
                notifyOnAnswer
                permalink
                qualityKind
                replyCount
                replyExpandKeys
                showLowQualityNotice
                sumVotesIncremented
                upVoted
                ... on QuestionFeedback {
                    hasAnswered
                    answers {
                        isLocked
                        isPinned
                        replyCount
                        appearsAsDeleted
                        author {
                            id
                            kaid
                            nickname
                            avatar {
                                name
                                imageSrc
                            }
                        }
                        content
                        date
                        definitelyNotSpam
                        deleted
                        downVoted
                        expandKey
                        feedbackType
                        flaggedBy
                        flags
                        focusUrl
                        focus {
                            kind
                            id
                            translatedTitle
                            relativeUrl
                        }
                        fromVideoAuthor
                        key
                        lowQualityScore
                        notifyOnAnswer
                        permalink
                        qualityKind
                        replyCount
                        replyExpandKeys
                        showLowQualityNotice
                        sumVotesIncremented
                        upVoted
                    }
                    isOld
                    answerCount
                }
                ... on AnswerFeedback {
                    question {
                        isLocked
                        isPinned
                        replyCount
                        appearsAsDeleted
                        author {
                            id
                            kaid
                            nickname
                            avatar {
                                name
                                imageSrc
                            }
                        }
                        content
                        date
                        definitelyNotSpam
                        deleted
                        downVoted
                        expandKey
                        feedbackType
                        flaggedBy
                        flags
                        focusUrl
                        focus {
                            kind
                            id
                            translatedTitle
                            relativeUrl
                        }
                        fromVideoAuthor
                        key
                        lowQualityScore
                        notifyOnAnswer
                        permalink
                        qualityKind
                        replyCount
                        replyExpandKeys
                        showLowQualityNotice
                        sumVotesIncremented
                        upVoted
                    }
                }
            }
            domainId
            cursor
            complete
            length
            topic {
                id
                slug
                translatedTitle
                relativeUrl
                description
                title
                creationDate
                kind
                translatedDescription
            }
        }
    }
`);
